import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { SkeletonModule } from 'primeng/skeleton';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

import { AcanTableComponent } from './data-table/acan-table.component';
import { AcanCellDirective } from './data-table/acan-cell.directive';
import { AcanFormShellComponent } from './form/acan-form-shell.component';
import { AcanFieldComponent } from './form/acan-field.component';
import { AcanSwitchComponent } from './controls/acan-switch.component';
import { AcanSelectComponent } from './controls/acan-select.component';
import { AcanInputComponent } from './controls/acan-input.component';
import { AcanMultiselectComponent } from './controls/acan-multiselect.component';
import { AcanDateComponent } from './controls/acan-date.component';
import { AcanEmptyStateComponent } from './feedback/acan-empty-state.component';
import { AcanModalComponent } from './feedback/acan-modal.component';

/**
 * NotificationService and ConfirmService are providedIn: 'root'.
 * Import AcanUiModule (or provide MessageService / ConfirmationService + p-toast / p-confirmDialog
 * in the host module) before injecting those services.
 */
const ACAN_UI_COMPONENTS = [
  AcanTableComponent,
  AcanCellDirective,
  AcanFormShellComponent,
  AcanFieldComponent,
  AcanSwitchComponent,
  AcanSelectComponent,
  AcanInputComponent,
  AcanMultiselectComponent,
  AcanDateComponent,
  AcanEmptyStateComponent,
  AcanModalComponent,
];

@NgModule({
  declarations: [...ACAN_UI_COMPONENTS],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TableModule,
    DropdownModule,
    MultiSelectModule,
    InputSwitchModule,
    InputTextModule,
    CalendarModule,
    DialogModule,
    ButtonModule,
    RippleModule,
    SkeletonModule,
    ToastModule,
    ConfirmDialogModule,
  ],
  exports: [
    ...ACAN_UI_COMPONENTS,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    DropdownModule,
    MultiSelectModule,
    InputSwitchModule,
    InputTextModule,
    CalendarModule,
    DialogModule,
    ButtonModule,
    RippleModule,
    SkeletonModule,
    ToastModule,
    ConfirmDialogModule,
  ],
})
export class AcanUiModule {}

export { AcanColumn, AcanTableConfig } from './data-table/acan-table.types';
export { AcanCellDirective } from './data-table/acan-cell.directive';
export { NotificationService } from './services/notification.service';
export { ConfirmService } from './services/confirm.service';
